import { MdRemoveCircleOutline } from 'react-icons/md';
import { DateCell, TickerCell } from '../utils/tableHandlers';
import { useMemo } from 'react';
import { useAuth } from '../context/auth';
import Tooltip from '../components/Tooltip';
import { calculateDaysToExpiration, formatNumber } from '../utils/mathHelpers';
import { HiQuestionMarkCircle } from 'react-icons/hi';
import { getBgColor } from '../utils/stylingHelpers';

export const WheelIncomeCallsColumns = ({
  handleDelete,
  updateData,
  sellingType,
  isDecayVisible,
  footerSums,
}) => {
  return useMemo(() => [
    {
      id: 'delete',
      accessorKey: 'delete',
      header: <h6 className='block w-full h-6'></h6>,
      cell: (info) => (
        <>
          {info.row.original._id && (
            <button
              className='px-2 py-1 w-full flex justify-center items-center'
              onClick={() => handleDelete(info.row)}
            >
              <MdRemoveCircleOutline className='w-5 h-5 fill-red-600' />
            </button>
          )}
        </>
      ),
      size: 50,
      maxSize: 100,
      minSize: 30,
      enableResizing: true,
    },
    {
      id: 'WheelIncomeCallCompanyName',
      header: (
        <h6 className='px-4 py-1 w-full text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Company Name
        </h6>
      ),
      accessorKey: 'WheelIncomeCallCompanyName',
      cell: (info) => {
        return (
          <div className={`px-4 py-1 flex justify-between space-x-2 w-full`}>
            <h6
              className={` ${info.row.getValue('WheelIncomeCallCompanyName') === 'Pending...'
                ? 'text-gray-500 italic'
                : info.row.getValue('WheelIncomeCallCompanyName')
                  ? ''
                  : 'text-red-500 italic'
                } flex-1 text-left `}
              style={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
              }}
            >
              {info.row.getValue('WheelIncomeCallCompanyName')
                ? info.row.getValue('WheelIncomeCallCompanyName')
                : info.row.original._id
                  ? 'Not found'
                  : ''}
            </h6>
            <Tooltip
              icon={
                <HiQuestionMarkCircle
                  className={`w-5 h-5 ${info.row.getValue('WheelIncomeCallCompanyName') ===
                    'Pending...'
                    ? 'fill-[#ffc954]'
                    : info.row.getValue('WheelIncomeCallCompanyName')
                      ? 'fill-[#3e63decc]'
                      : info.row.original._id
                        ? 'fill-[#ff3737]'
                        : 'fill-[#949494]'
                    }`}
                />
              }
              content={
                info.row.getValue('WheelIncomeCallCompanyName') === 'Pending...'
                  ? 'Pending...'
                  : !info.row.original._id
                    ? 'Please type a Ticker'
                    : info.row.getValue('WheelIncomeCallCompanyName')
                      ? info.row.original.description
                      : 'Not found'
              }
              type='text'
              color={`${info.row.getValue('WheelIncomeCallCompanyName') === 'Pending...'
                ? 'bg-[#ffc954]'
                : info.row.getValue('WheelIncomeCallCompanyName')
                  ? 'bg-[#6582e5]'
                  : info.row.original._id
                    ? 'bg-red-600'
                    : 'bg-gray-400'
                }`}
              tooltipClass='max-w-md whitespace-normal break-words'
              tooltipStyle={{
                border: `3px solid  ${info.row.getValue('WheelIncomeCallCompanyName') ===
                  'Pending...'
                  ? '#ffc924'
                  : info.row.getValue('WheelIncomeCallCompanyName')
                    ? '#3e64de'
                    : info.row.original._id
                      ? '#ff3737'
                      : '#949494'
                  }`,
                width: '300px',
                maxHeight: '200px',
                overflowY: 'auto',
                zIndex: '999',
              }}
            />
          </div>
        );
      },
      size: 150,
      maxSize: 250,
      minSize: 120,
    },
    {
      id: 'WheelIncomeCallTicker',
      header: (
        <h6
          id='tickerHeader'
          className='px-4 py-1 w-full sticky text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '
        >
          ticker
        </h6>
      ),
      accessorKey: 'WheelIncomeCallTicker',
      cell: (info) => {
        return (
          <TickerCell
            updateData={updateData}
            row={info.row}
            columnId={'WheelIncomeCallTicker'}
            page='wheelIncome'
            sellingType={sellingType}
          />
        );
      },
      size: 100,
      maxSize: 150,
      minSize: 90,
    },
    {
      id: 'WheelIncomeCallCurrentPrice',
      accessorKey: 'WheelIncomeCallCurrentPrice',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Current $
        </h6>
      ),
      cell: (info) => (
        <span
          className={`w-full px-4 py-1 flex items-center justify-end text-end`}
        >
          {info.getValue() && `$ ${formatNumber(info.getValue())}`}
        </span>
      ),
      size: 125,
      maxSize: 150,
      minSize: 100,
    },
    {
      id: 'WheelIncomeCallSector',
      accessorKey: 'WheelIncomeCallSector',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Sector
        </h6>
      ),
      cell: (info) => {
        return (
          <span className='w-full px-4 py-1 flex items-center  font-medium'>
            {info.getValue()}
          </span>
        );
      },
      size: 125,
      maxSize: 150,
      minSize: 100,
    },
    {
      id: 'WheelIncomeCallIndustry',
      accessorKey: 'WheelIncomeCallIndustry',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          industry
        </h6>
      ),
      cell: (info) => {
        return (
          <span className='w-full px-4 py-1 flex items-center justify-start  font-medium'>
            {info.getValue()}
          </span>
        );
      },
      size: 125,
      maxSize: 150,
      minSize: 100,
    },

    {
      id: 'WheelIncomeCallPriceStockWasBought',
      accessorKey: 'WheelIncomeCallPriceStockWasBought',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          $ stock bought
        </h6>
      ),
    },
    {
      id: 'WheelIncomeCallNumberOfShares',
      accessorKey: 'WheelIncomeCallNumberOfShares',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          NB shares
        </h6>
      ),
    },
    {
      id: 'WheelIncomeCallOptionStrikePrice',
      accessorKey: 'WheelIncomeCallOptionStrikePrice',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Option strike $
        </h6>
      ),
    },
    {
      id: 'WheelIncomeCallRisePercent',
      accessorKey: 'WheelIncomeCallRisePercent',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Rise %
        </h6>
      ),
      cell: (info) => {
        const priceStockWasBought = info.row.getValue(
          'WheelIncomeCallPriceStockWasBought'
        );
        const strikePrice = info.row.getValue(
          'WheelIncomeCallOptionStrikePrice'
        );
        const risePercent =
          priceStockWasBought && strikePrice
            ? ((strikePrice - priceStockWasBought) / priceStockWasBought) * 100
            : null;

        return (
          <span className='w-full px-4 py-1 flex items-center justify-end text-end'>
            {risePercent !== null ? `${formatNumber(risePercent, 0)}%` : ''}
          </span>
        );
      },
      size: 100,
      maxSize: 200,
      minSize: 50,
    },
    {
      id: 'WheelIncomeCallOptionPremium',
      accessorKey: 'WheelIncomeCallOptionPremium',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Option prem
        </h6>
      ),
      size: 100,
      maxSize: 200,
      minSize: 50,
    },
    {
      id: 'WheelIncomeCallDateSoldOption',
      accessorKey: 'WheelIncomeCallDateSoldOption',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          date Sold Option
        </h6>
      ),
      cell: (info) => {
        return (
          <DateCell
            updateData={updateData}
            row={info.row}
            columnId={'WheelIncomeCallDateSoldOption'}
            page='WheelIncome'
            sellingType={sellingType}
          />
        );
      },
      size: 135,
      maxSize: 200,
      minSize: 130,
    },
    {
      id: 'WheelIncomeCallExpDate',
      accessorKey: 'WheelIncomeCallExpDate',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Expiration date
        </h6>
      ),
      cell: (info) => {
        return (
          <DateCell
            updateData={updateData}
            row={info.row}
            columnId={'WheelIncomeCallExpDate'}
            page='WheelIncome'
            sellingType={sellingType}
          />
        );
      },
      size: 135,
      maxSize: 200,
      minSize: 130,
    },

    {
      id: 'WheelIncomeCallDaysToExpiration',
      accessorKey: 'WheelIncomeCallDaysToExpiration',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Days to exp
        </h6>
      ),
      cell: (info) => {
        const daysToExpiration = calculateDaysToExpiration(
          info.row.original.WheelIncomeCallExpDate,
          'UTC',
          info.row.original.WheelIncomeCallDateSoldOption
        );

        return (
          <div className={`px-4 py-1  flex items-center justify-center w-full`}>
            <span className='text-sm'>
              {daysToExpiration === 'Expired'
                ? 'Expired'
                : daysToExpiration === null
                  ? ''
                  : `${daysToExpiration} days`}
            </span>
          </div>
        );
      },
      size: 125,
      maxSize: 150,
      minSize: 100,
    },
    {
      id: 'WheelIncomeCallOptionsToTrade',
      accessorKey: 'WheelIncomeCallOptionsToTrade',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          NB OPTIONS
        </h6>
      ),
      size: 125,
      maxSize: 150,
      minSize: 100,
    },
    {
      id: 'WheelIncomeCallPremiumCollected',
      accessorKey: 'WheelIncomeCallPremiumCollected', // Accessor for the value from your row data
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Prem collected
        </h6>
      ),
      cell: (info) => {
        // Assuming that info.row has the number of options and the premium per option
        const numberOfOptions = info.row.getValue(
          'WheelIncomeCallOptionsToTrade'
        );
        const premium = info.row.getValue('WheelIncomeCallOptionPremium');
        const premiumCollected =
          numberOfOptions && premium
            ? numberOfOptions * premium * 100 // Each option usually represents 100 shares
            : 0; // Default to 0 if values are not present

        return (
          <span className='w-full px-4 py-1 flex items-center justify-end text-end'>
            {`$ ${formatNumber(premiumCollected)}`}
          </span>
        );
      },
      size: 125,
      maxSize: 150,
      minSize: 100,
    },
    {
      id: 'WheelIncomeCallPremiumPerDay',
      accessorKey: 'WheelIncomeCallPremiumPerDay',
      header: (
        <h6 className='px-4 py-1 text-center font-bold  text-green-900 whitespace-nowrap text-ellipsis text-xs  uppercase tracking-wider '>
          Prem per day
        </h6>
      ),
      cell: (info) => {
        // Assuming info.row has the Prem collected and days to expiration
        const numberOfOptions = info.row.getValue(
          'WheelIncomeCallOptionsToTrade'
        );
        const premium = info.row.getValue('WheelIncomeCallOptionPremium');
        const premiumCollected =
          numberOfOptions && premium ? numberOfOptions * premium * 100 : 0; // Each option usually represents 100 shares

        // Use the calculateDaysToExpiration function to get the days to expiration
        const daysToExpiration = calculateDaysToExpiration(
          info.row.original.WheelIncomeCallExpDate,
          'UTC',
          info.row.original.WheelIncomeCallDateSoldOption
        );

        // Check if daysToExpiration is "Expired", a negative value, or null before calculating WheelIncomeCallPremiumPerDay
        let WheelIncomeCallPremiumPerDay = 0;
        if (
          daysToExpiration &&
          daysToExpiration !== 'Expired' &&
          daysToExpiration > 0
        ) {
          WheelIncomeCallPremiumPerDay = premiumCollected / daysToExpiration;
        }

        // Get the background color based on some condition, assuming getBgColor is a function that returns a color class name
        const bgColorClass = getBgColor('WheelIncomeCallPremiumPerDay');

        return (
          <span
            className={`w-full px-4 py-1 ${bgColorClass} flex items-center text-green-900 font-bold justify-end text-end`}
          >
            {WheelIncomeCallPremiumPerDay > 0
              ? `$ ${formatNumber(WheelIncomeCallPremiumPerDay, 0)}`
              : daysToExpiration === 'Expired'
                ? 'Expired'
                : 0}
          </span>
        );
      },

      size: 125,
      maxSize: 150,
      minSize: 100,
    },
    {
      id: 'WheelIncomeCallValueAtStrike',
      accessorKey: 'WheelIncomeCallValueAtStrike',
      header: (
        <h6 className='px-4 py-1 text-center text-red-900 whitespace-nowrap text-ellipsis text-xs font-bold uppercase tracking-wider '>
          value At Strike
        </h6>
      ),
      cell: (info) => {
        // Assuming info.row has the put option strike price and the number of NB OPTIONS
        const numberOfShares = info.row.getValue(
          'WheelIncomeCallNumberOfShares'
        );
        const WheelIncomeCallOptionStrikePrice = info.row.getValue(
          'WheelIncomeCallOptionStrikePrice'
        );

        // Calculate the total amount needed to buy stock if assigned
        const valueAtStrike =
          numberOfShares && WheelIncomeCallOptionStrikePrice
            ? numberOfShares * WheelIncomeCallOptionStrikePrice // Each option usually represents 100 shares
            : 0;

        // Get the background color based on some condition, assuming getBgColor is a function that returns a color class name
        const bgColorClass = getBgColor('WheelIncomeCallValueAtStrike');

        return (
          <span
            className={`w-full px-4 py-1 flex text-red-900 font-bold items-center ${bgColorClass} justify-end text-end`}
          >
            {`$ ${formatNumber(valueAtStrike, 0)}`}
          </span>
        );
      },

      size: 125,
      maxSize: 150,
      minSize: 100,
    },
    {
      id: 'WheelIncomeCallPremiumAnnualized',
      accessorKey: 'WheelIncomeCallPremiumAnnualized',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Prem annualized
        </h6>
      ),
      cell: (info) => {
        // Assuming info.row has the Prem collected, needed to buy stock, and days to expiration
        const WheelIncomeCallOptionsToTrade = info.row.getValue(
          'WheelIncomeCallOptionsToTrade'
        );
        const premium = info.row.getValue('WheelIncomeCallOptionPremium');
        const premiumCollected =
          WheelIncomeCallOptionsToTrade && premium
            ? WheelIncomeCallOptionsToTrade * premium * 100 // Each option usually represents 100 shares
            : 0; // Default to 0 if values are not present

        const WheelIncomeCallPriceStockWasBought = info.row.getValue(
          'WheelIncomeCallPriceStockWasBought'
        );

        // Calculate the total amount needed to buy stock if assigned
        // const neededToBuyStock =
        // WheelIncomeCallPriceStockWasBought && WheelIncomeCallOptionsToTrade
        //     ? WheelIncomeCallPriceStockWasBought * WheelIncomeCallOptionsToTrade // Each option usually represents 100 shares
        //     : 0;
        const daysToExpiration = calculateDaysToExpiration(
          info.row.original.WheelIncomeCallExpDate,
          'UTC',
          info.row.original.WheelIncomeCallDateSoldOption
        );

        // If days to expiration is 0, expired, or null, annualized premium cannot be calculated
        const isExpiredOrInvalid =
          !daysToExpiration ||
          daysToExpiration <= 0 ||
          daysToExpiration === 'Expired';
        const numberOfShares = info.row.getValue(
          'WheelIncomeCallNumberOfShares'
        );
        // Calculate the Prem annualized, typically:
        // ( (premiumCollected / daysToExpiration) * 365 ) / (neededToBuyStock) * 100

        const premiumAnnualized =
          !isExpiredOrInvalid && WheelIncomeCallPriceStockWasBought
            ? ((((premiumCollected / daysToExpiration) * 360) /
              WheelIncomeCallPriceStockWasBought) *
              numberOfShares) /
            100
            : 0;

        return (
          <span
            className={`w-full px-4 py-1 flex items-center justify-end text-end`}
          >
            {premiumAnnualized > 0
              ? `${formatNumber(premiumAnnualized, 0)}%`
              : daysToExpiration === 'Expired'
                ? 'Expired'
                : ''}
          </span>
        );
      },

      size: 125,
      maxSize: 150,
      minSize: 100,
    },
    {
      id: 'WheelIncomeCallStockGainsIfExercised',
      accessorKey: 'WheelIncomeCallStockGainsIfExercised',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap font-bold  text-green-900 text-ellipsis text-xs uppercase tracking-wider '>
          Stock Gains If Exercised
        </h6>
      ),
      cell: (info) => {
        const priceStockWasBought = info.row.getValue(
          'WheelIncomeCallPriceStockWasBought'
        );
        const strikePrice = info.row.getValue(
          'WheelIncomeCallOptionStrikePrice'
        );
        const numberOfShares = info.row.getValue(
          'WheelIncomeCallNumberOfShares'
        );

        // Calculate stock gains if the options are exercised
        const stockGains =
          strikePrice && priceStockWasBought && numberOfShares
            ? (strikePrice - priceStockWasBought) * numberOfShares
            : 0;

        return (
          <span className='w-full px-4 py-1 flex items-center justify-end font-bold  text-green-900 bg-green-100 text-end'>
            {stockGains > 0 ? `$ ${formatNumber(stockGains, 0)}` : '$ 0'}
          </span>
        );
      },

      size: 125,
      maxSize: 150,
      minSize: 100,
    },
    {
      id: 'WheelIncomeCallStockGains',
      accessorKey: 'WheelIncomeCallStockGains',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Stock Gains
        </h6>
      ),
      cell: (info) => {
        const priceStockWasBought = info.row.getValue(
          'WheelIncomeCallPriceStockWasBought'
        );
        const strikePrice = info.row.getValue(
          'WheelIncomeCallOptionStrikePrice'
        );

        // Calculate the percentage stock gains if the call options are exercised
        const stockGainsPercent =
          priceStockWasBought && strikePrice
            ? ((strikePrice - priceStockWasBought) / priceStockWasBought) * 100
            : 0;

        return (
          <span className='w-full px-4 py-1 flex items-center justify-end text-end'>
            {stockGainsPercent > 0
              ? `${formatNumber(stockGainsPercent, 0)}%`
              : '0%'}
          </span>
        );
      },
      size: 125,
      maxSize: 150,
      minSize: 100,
    },
    {
      id: 'WheelIncomeCallTotalGained',
      accessorKey: 'WheelIncomeCallTotalGained',
      header: (
        <h6 className='px-4 py-1 text-center whitespace-nowrap text-ellipsis text-xs font-medium text-gray-500 uppercase tracking-wider '>
          Total gain
        </h6>
      ),
      cell: (info) => {
        const premium = info.row.getValue('WheelIncomeCallOptionPremium');
        const numberOfOptions = info.row.getValue(
          'WheelIncomeCallOptionsToTrade'
        );
        const premiumCollected =
          premium && numberOfOptions
            ? premium * numberOfOptions * 100 // Each option usually represents 100 shares
            : 0;

        const priceStockWasBought = info.row.getValue(
          'WheelIncomeCallPriceStockWasBought'
        );
        const strikePrice = info.row.getValue(
          'WheelIncomeCallOptionStrikePrice'
        );
        const numberOfShares = info.row.getValue(
          'WheelIncomeCallNumberOfShares'
        );
        const stockGains =
          strikePrice && priceStockWasBought && numberOfShares
            ? (strikePrice - priceStockWasBought) * numberOfShares
            : 0;

        const totalGained = premiumCollected + stockGains;

        return (
          <span
            className={`w-full px-4 py-1 flex items-center font-bold text-green-900 bg-green-100 justify-end text-end`}
          >
            {totalGained > 0 ? `$ ${formatNumber(totalGained, 0)}` : '$ 0'}
          </span>
        );
      },
      size: 125,
      maxSize: 150,
      minSize: 100,
    },
  ]);
};
